import React, { useContext, createContext } from 'react';
import QueryString, { ParsedQs } from 'qs';

export interface Tracking extends ParsedQs {
  utm_source?: string;
  utm_campaign?: string;
  utm_medium?: string;
  utm_term?: string;
  utm_content?: string;
  tid?: string;
}

const rawParams = QueryString.parse(window.location.search, {
  ignoreQueryPrefix: true,
});
const { access_token, ...safeParams } = rawParams as Record<string, unknown>;

const currentParams = {
  ...safeParams,
  utm_source: rawParams['ref']
    ? 'ref'
    : String(rawParams['utm_source'] || '') || undefined,
  utm_content:
    String(rawParams['ref'] || '') ||
    String(rawParams['utm_content'] || '') ||
    undefined,
  tid:
    String(rawParams['tid'] || '') ||
    String(rawParams['trackingId'] || '') ||
    String(rawParams['trackingid'] || '') ||
    String(rawParams['tracking_id'] || '') ||
    String(rawParams['tandemzId'] || '') ||
    String(rawParams['tandemzid'] || '') ||
    String(rawParams['tandemz_id'] || '') ||
    String(rawParams['SPM_PANELIST_ID'] || '') ||
    undefined,
  panel: String(rawParams['panel'] || '') || undefined,
};

export const TrackingParamsContext = createContext<Tracking>(currentParams);

const { Provider } = TrackingParamsContext;

export const TrackingParamsContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <Provider value={currentParams} children={children} />;
};
export const useTrackingParams = () => useContext(TrackingParamsContext);
